import Base from './base';

export default {
  getList: async (limit?: number, page?: number): Promise<any> => {
    const url = `product-types/?${limit ? `limit=${limit}` : ''}${page ? `&page=${page}` : ''}`;
    return (await Base()).get(url);
  },
};
